import { render, staticRenderFns } from "./GroupTemplate.vue?vue&type=template&id=5f44b930&"
import script from "./GroupTemplate.vue?vue&type=script&lang=js&"
export * from "./GroupTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports